import { render, staticRenderFns } from "./AgreedDeduction.vue?vue&type=template&id=4778b4d7&scoped=true"
import script from "./AgreedDeduction.vue?vue&type=script&lang=js"
export * from "./AgreedDeduction.vue?vue&type=script&lang=js"
import style0 from "./AgreedDeduction.vue?vue&type=style&index=0&id=4778b4d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778b4d7",
  null
  
)

export default component.exports